import React, { FC, useCallback } from "react";
import { IconWithTooltip } from "components/Elements/Icon/Icon.tsx";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useMail } from "contexts/mailContext/mailContext.js";
import EditEmailModal from "components/Reusable/EditEmailModal/EditEmailModal.js";
import useMailSender from "hooks/useMailSender.js";
import { useUser } from "contexts/userContext/userContext";
import PopupContainer from "components/Reusable/PopupContainer/PopupContainer.js";
import UploadBrandedCoverPopup from "components/Reusable/PopupContainer/UploadBrandedCoverPopup.js";
import { useContent } from "contexts/contentContext/contentContext.js";

export const OwnerActions: FC = () => {
  const {
    getMailMetaData,
    getMailId,
    setMetaDataProp,
    getSender,
    getBackgroundCover,
  } = useMail();
  const { setModal } = useModal();
  const { isMailSender, isMailSenderAndBusinessSubscriber } = useMailSender();
  const { getUserData } = useUser();
  const { getTextByKey } = useContent();

  const handleEditSubject = () => {
    setModal({
      modal: EditEmailModal,
      props: {
        subject: getMailMetaData().subjectText,
        message: getMailMetaData().bodyText,
        emailId: getMailId(),
        userNameDisplay: getMailMetaData().DisplaySenderName,
        subjectDisplay: getMailMetaData().DisplayEmailSubject,
        callbackUpdateProps: ({
          subjectValue,
          messageValue,
          displaySenderName,
          displaySubject,
        }: {
          subjectValue: string;
          messageValue: string;
          displaySenderName: boolean;
          displaySubject: boolean;
        }) => {
          setMetaDataProp("subjectText", subjectValue);
          setMetaDataProp("bodyText", messageValue);
          setMetaDataProp("DisplaySenderName", displaySenderName);
          setMetaDataProp("DisplayEmailSubject", displaySubject);
        },
      },
    });
  };

  const CallToAction = useCallback(() => {
    return isMailSenderAndBusinessSubscriber() ||
      (isMailSender() &&
        (getBackgroundCover() || getSender()?.brandedHeader?.Avatar)) ? (
      <>
        <span className="vertical-divider" />
        <PopupContainer
          containerClassName="background-branding-cover-call-to-action"
          icon={isMailSenderAndBusinessSubscriber() ? "branding" : "i"}
          tooltipKey={
            isMailSenderAndBusinessSubscriber()
              ? "background-branding-cover-icon-tooltip-text"
              : "not-subscriber-background-branding-cover-icon-tooltip-text"
          }
          large
        >
          <UploadBrandedCoverPopup />
        </PopupContainer>
      </>
    ) : (
      <></>
    );
  }, [getUserData()]);

  if (!isMailSender()) {
    return null;
  }

  return (
    <div className="email-owner-actions">
      <button
        className={`edit-subject-icon${
          getMailMetaData().subjectText && getMailMetaData().DisplayEmailSubject
            ? ""
            : " no-subject"
        }`}
        onClick={handleEditSubject}
        aria-label={getTextByKey("edit-mail-details")}
      >
        <IconWithTooltip
          iconProps={{
            name: "edit-pen-solid",
            gray: true,
          }}
          tooltipProps={{
            tooltipTextKey: "edit-mail-details",
          }}
        />
      </button>

      <CallToAction />
    </div>
  );
};
